import { createReducer, on } from '@ngrx/store';
import { resetAllCustomPdfReportItems } from '../actions';
import { setRiskProfile } from './risk-profile.actions';
export const riskProfile = createReducer(null, on(setRiskProfile, (state, action) => {
    return action.riskProfile;
}), on(resetAllCustomPdfReportItems, () => {
    return null;
}));
